export default "__VITE_ASSET__DrcBjXUS__"